import React, { useState } from "react";
import minus from "../../assets/images/model/minus.png";
import close from "../../assets/images/model/close.png";
import angleDown from "../../assets/images/model/angle-down.png";
import drag from "../../assets/images/model/drag.png";
import addImg from "../../assets/images/model/add-img.png";
import addVideos from "../../assets/images/model/add-vedio.png";
import addAudio from "../../assets/images/model/dd-audio.png";
import ArrowUp from "../../assets/images/model/errow-up.svg";
import arrowDown from "../../assets/images/model/arrow-down.png";
import edite from "../../assets/images/model/edite.png";
import userImag from "../../assets/images/model/user_img.png";
import close1 from "../../assets/images/model/cross-white.svg";
import "./createbook.css";
import "./createbookresponsive.css";
import GreyledHeader from "../../components/createmode/created";
import GrayledDropdown from "../../components/GrayledDropdown";

export const CreateBook = () => {
  const [activeButton, setActiveButton] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [iselectOption, setIselectOption] = useState("chapter");
  const [showChildDropdown, setShowChildDropdown] = useState(false);

  const [activeItem, setActiveItem] = useState(null);

  const createInput = (item) => {
    if (item === "chapter-header") {
      return <input type="text" placeholder="Chapter header" />;
    } else if (item === "section-header") {
      return <input type="text" placeholder="Section header" />;
    } else {
      return null; // In case of no match
    }
  };

  const handleParentClick = (item) => {
    setActiveItem(item);
    setShowChildDropdown(item);
  };
  const handleClick = () => {
    setIsClicked(true);
  };
  const handleOptionClick = (option) => {
    setIselectOption(option);
    setIsClicked(false);
  };
  const handleButtonClick = (index) => {
    setActiveButton(index);
  };
  return (
    <div className="main_wrapss">
      <div className="main_wrap_inner_create" style={{ overflow: "hidden" }}>
        <div className="left_side_bar_create">
          <div className="top_content ">
            <div className="logo_brand_create">
              <GrayledDropdown mode="create" />
              {/* <img src={close1} alt="clsoe " className="close_menu" /> */}
            </div>
            <ul
              className="nav nav-tabs custom_tabs_create "
              id="custom_tabs_create"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="Contents-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Contents"
                  type="button"
                  role="tab"
                  aria-controls="Contents"
                  aria-selected="true"
                >
                  Contents
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="Details-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#Details"
                  type="button"
                  role="tab"
                  aria-controls="Details"
                  aria-selected="false"
                >
                  Details
                </button>
              </li>
            </ul>
            <div className="tab-content" id="custom_tabsContent">
              <div
                className="tab-pane fade show active"
                id="Contents"
                role="tabpanel"
                aria-labelledby="Contents-tab"
              >
                <div className="Contents_Wrap_create accordion_Wrap">
                  <h1 className="f-16 mini_title">Greyled 101</h1>
                  <div
                    className="accordion accordion-flush"
                    id="accordionFlushExample"
                  >
                    <div className="accordion-item">
                      <div className="inner_Wrap_create">
                        <h2 className="accordion-header after_shap_create">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#flush-collapseOne"
                            aria-expanded="false"
                            aria-controls="flush-collapseOne"
                          >
                            Introduction to Greyled create mode
                          </button>
                        </h2>
                        <a href="" className="minus_icon">
                          <img src={minus} alt="close" />
                        </a>
                      </div>
                      <div
                        id="flush-collapseOne"
                        className="accordion-collapse collapse"
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="accordion-body faq_inner">
                          <div className="accordion-item">
                            <div className="inner_Wrap">
                              <h2 className="accordion-header">
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse_inner"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse_inner"
                                >
                                  Learning objectives
                                </button>
                              </h2>
                            </div>
                            <div
                              id="flush-collapse_inner"
                              className="accordion-collapse collapse"
                              data-bs-parent="#accordionFlush_inner"
                            >
                              <div className="accordion-body">
                                <p className="text-Purple f-14">
                                  How to create with Greyled
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="custom_droup_down">
                    <button
                      type="button"
                      className="add_more_btn_create"
                      onClick={handleClick}
                    >
                      <img src={close} alt="close" />
                      Add{" "}
                      <u className={isClicked ? "select-chapter-section" : ""}>
                        {iselectOption}
                      </u>{" "}
                      option
                    </button>
                    {isClicked && (
                      <ul class="">
                        <li onClick={() => handleOptionClick("chapter")}>
                          chapter
                        </li>
                        <li onClick={() => handleOptionClick("section")}>
                          section
                        </li>
                      </ul>
                    )}
                  </div>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="Details"
                role="tabpanel"
                aria-labelledby="Details-tab"
              >
                <div className="details_wrap"></div>
              </div>
            </div>
          </div>
          <div className="bottom_button_create">
            <div className="bottom_tabs_new_create d-none">
              <a href="" className="angle_down_btn_create">
                <img src={angleDown} alt="angle" />
                CLOSS
              </a>

              <ul
                className="nav nav-tabs custom_tabs_create create"
                id="custom_tabs_bottm"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="add_a_block-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#add_a_block"
                    type="button"
                    role="tab"
                    aria-controls="Contents"
                    aria-selected="true"
                  >
                    Add a block
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="Add_media-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Add_media"
                    type="button"
                    role="tab"
                    aria-controls="Add_media"
                    aria-selected="false"
                  >
                    Add media
                  </button>
                </li>
              </ul>

              <div className="tab-content" id="custom_tabsContent_bottom">
                <div
                  className="tab-pane fade show active"
                  id="add_a_block"
                  role="tabpanel"
                  aria-labelledby="add_a_block-tab"
                >
                  <div className="Contents_Wrap_create accordion_Wrap">
                    <div className="drag_and_drop">
                      <div className="drag_and_drop_box_img">
                        <img src={drag} className="d-block w-100" alt="" />
                      </div>
                      <div className="drag_and_drop_box_img">
                        <img src={drag} className="d-block w-100" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="Add_media"
                  role="tabpanel"
                  aria-labelledby="Add_media-tab"
                >
                  <div className="details_wrap">
                    <div className="drag_and_drop">
                      <div className="drag_and_drop_box_img">
                        <img src={addImg} className="d-block w-100" alt="" />
                      </div>
                      <div className="drag_and_drop_box_img">
                        <img src={addVideos} className="d-block w-100" alt="" />
                      </div>
                      <div className="drag_and_drop_box_img">
                        <img src={addAudio} className="d-block w-100" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button type="button" className="open_button_create">
              Add a textbook block <img src={ArrowUp} alt="arrowUp" />
            </button>
          </div>
        </div>
        <div className="main_center_content_create">
          <div className="top_header_create">
            <GreyledHeader />
          </div>
          <div className="main_center_content_inner_create">
            <div className="center_conter_wrap_create">
              {/* <TextEditor /> */}
              <div className="center_conter_head_create">
                <h1>
                  <b>Greyled 101 </b>| Giovanni zimotti
                </h1>
                <h1>
                  <b>CHAPTER 1, SECTION 1 </b>
                </h1>
              </div>
              <div
                className="center_conter_inner_create"
                style={{ paddingLeft: "2rem" }}
              >
                <h4 className="min_title_create">
                  Introduction to Greyled create mode
                </h4>
                <p>
                  Giovanni Zimotti, director of language instruction, Iowa State
                  University
                </p>
                <div className="my-32 Objectives_list_create  ">
                  <h5 className="sub_title_create">Learning Objectives</h5>
                  <ul className="sub_title_ul">
                    <li>Learn basics of create mode</li>
                    <li>
                      Use these building blocks to create your own textbook
                    </li>
                    <li>
                      Be able to customize and edit a textbook for your
                      classroom
                    </li>
                    <li>
                      Create custom activities and link directly to the book
                    </li>
                  </ul>
                </div>
                <div className="edit_text_create_book">
                  <a className="edit_option_cre">
                    <img src={edite} alt="edit" />
                  </a>
                  <p>
                    Greyled create mode allows a professor to write or upload
                    content to make their own textbooks. It can also be used to
                    edit an existing textbook with an open license so the
                    textbook will match the professor’s teaching needs. Create
                    mode has 3 building blocks to start. On the left hand side
                    in the content tab, add and name chapters by uploading
                    individual chapters from pdf or word documents - use our
                    word document template to get started fast. Are the chapters
                    in the wrong order? No problem! Chapters can be re-ordered
                    by dragging and dropping them in the order you prefer. This
                    allows a professor to set up students for success by
                    teaching in consecutive order of their textbook instead of
                    jumping around chapters. In the details tab, upload a cover
                    image, add authors, license information and more.
                  </p>

                  <p>
                    On the right hand side we have the activities area. Create
                    your own activities and flashcards (coming soon) to
                    associate directly to the textbook. Not sure where to start?
                    Check out the explore tab for activities created by authors
                    using similar textbooks or the same if you are editing
                    another author’s textbook. Easily sort and edit activities,
                    or delete them altogether if you are not wanting to use
                    them. If the activity was created by the original author of
                    a textbook you are editing, the activity will be
                    unassociated but not removed from the book. This will allow
                    you to associate the activity once more at a later time
                    without losing track of it. Have more questions? Reach out
                    to support at greyled.com.
                  </p>
                </div>
                <div className="bottom_button_wrap">
                  <button type="button" className="btn_white_outline">
                    Save changes
                  </button>
                  <button type="button" className="btn_white_outline">
                    Push changes to class
                  </button>
                </div>
              </div>
            </div>
            <div className="right_side_bar_create">
              <div className="top_content">
                <ul
                  className="nav nav-tabs custom_tabs_create create"
                  id="custom_tabs_sec"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="my_book-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#my_book"
                      type="button"
                      role="tab"
                      aria-controls="my_book"
                      aria-selected="true"
                    >
                      Assigned
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="explore-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#explore"
                      type="button"
                      role="tab"
                      aria-controls="explore"
                      aria-selected="false"
                    >
                      Linked to book
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="custom_tabs_secContent">
                  <div className="check_box_wrap_create-library">
                    <button
                      className={`activities-checkbox ${
                        activeButton === 0 ? "active-button-create" : ""
                      }`}
                      onClick={() => handleButtonClick(0)}
                    >
                      <div className="checkbox-text">
                        My activities (6){" "}
                        <img
                          src={close1}
                          alt=""
                          style={{
                            marginTop: "-3px",
                            display:
                              activeButton === 0 ? "inline-block" : "none",
                          }}
                        />
                      </div>
                    </button>
                    <button
                      className={`activities-checkbox ${
                        activeButton === 1 ? "active-button-create" : ""
                      }`}
                      onClick={() => handleButtonClick(1)}
                    >
                      <div className="checkbox-text">
                        Original authors (6){" "}
                        <img
                          src={close1}
                          alt=""
                          style={{
                            marginTop: "-3px",
                            display:
                              activeButton === 1 ? "inline-block" : "none",
                          }}
                        />
                      </div>
                    </button>
                    <button
                      className={`activities-checkbox ${
                        activeButton === 2 ? "active-button-create" : ""
                      }`}
                      onClick={() => handleButtonClick(2)}
                    >
                      <div className="checkbox-text">
                        All authors (6){" "}
                        <img
                          src={close1}
                          alt=""
                          style={{
                            marginTop: "-3px",
                            display:
                              activeButton === 2 ? "inline-block" : "none",
                          }}
                        />
                      </div>
                    </button>
                  </div>
                  <div
                    className="tab-pane fade show active"
                    id="my_book"
                    role="tabpanel"
                    aria-labelledby="my_book-tab"
                  >
                    <div className="Contents_Wrap_create">
                      <div className="chapter_scroll">
                        <div className="chapter_box_create">
                          <div className="chapter_box_inner">
                            <div className="chapter_box_head_create">
                              <div className="content_head_cre">
                                <h5>teacher-graded</h5>
                                <p>chapter 1, section 3</p>
                              </div>
                              <div className="user_img_chapter_create">
                                <img src={userImag} alt="user" />
                              </div>
                            </div>
                            <div className="chapter_box_body_create">
                              <h2>Definition of terms</h2>
                              <p>
                                Step One: In Chapter 1 of Explorations, we
                                learned the difference between kn...
                              </p>
                              <h5>What is knowledge?</h5>
                              <h5>What is belief?</h5>
                              <h5>
                                What is the difference between these two
                                concepts?
                              </h5>
                            </div>
                            <div className="chapter_box_footer_create">
                              <h1>
                                <span>+1</span> other question
                              </h1>
                              <a href="">
                                Open
                                <img src={arrowDown} alt="arrow-down" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="explore"
                    role="tabpanel"
                    aria-labelledby="explore-tab"
                  >
                    <div className="chapter_scroll">
                      <div className="create-new-book">
                        <div className=" new-activity">
                          Create a new activity to add to your textbook
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bottom_button_create">
                <button type="button" className="open_button_create">
                  Create your own activity
                  <img src={ArrowUp} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
